module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ko_okinawa-5e06d483c71a2830ac513e9a5fdf4df3.jpg";